//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class DetailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getGeNominationDistrictDetail(nominationDistrictId: string): Observable<GeNominationDistrictDetailDto> {
        let url_ = this.baseUrl + "/api/detail/{nominationDistrictId}/ge-nomination-district-detail";
        if (nominationDistrictId === undefined || nominationDistrictId === null)
            throw new Error("The parameter 'nominationDistrictId' must be defined.");
        url_ = url_.replace("{nominationDistrictId}", encodeURIComponent("" + nominationDistrictId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeNominationDistrictDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeNominationDistrictDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeNominationDistrictDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeNominationDistrictDetailDto>;
        }));
    }

    protected processGetGeNominationDistrictDetail(response: HttpResponseBase): Observable<GeNominationDistrictDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeNominationDistrictDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvNominationDistrictDetail(nominationDistrictId: string): Observable<EvNominationDistrictDetailDto> {
        let url_ = this.baseUrl + "/api/detail/{nominationDistrictId}/ev-nomination-district-detail";
        if (nominationDistrictId === undefined || nominationDistrictId === null)
            throw new Error("The parameter 'nominationDistrictId' must be defined.");
        url_ = url_.replace("{nominationDistrictId}", encodeURIComponent("" + nominationDistrictId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvNominationDistrictDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvNominationDistrictDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvNominationDistrictDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvNominationDistrictDetailDto>;
        }));
    }

    protected processGetEvNominationDistrictDetail(response: HttpResponseBase): Observable<EvNominationDistrictDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvNominationDistrictDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFaNominationDistrictDetail(nominationDistrictId: string): Observable<FaNominationDistrictDetailDto> {
        let url_ = this.baseUrl + "/api/detail/{nominationDistrictId}/fa-nomination-district-detail";
        if (nominationDistrictId === undefined || nominationDistrictId === null)
            throw new Error("The parameter 'nominationDistrictId' must be defined.");
        url_ = url_.replace("{nominationDistrictId}", encodeURIComponent("" + nominationDistrictId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaNominationDistrictDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaNominationDistrictDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaNominationDistrictDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaNominationDistrictDetailDto>;
        }));
    }

    protected processGetFaNominationDistrictDetail(response: HttpResponseBase): Observable<FaNominationDistrictDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaNominationDistrictDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeElectionAreaDetails(electionAreaId: string): Observable<ElectionAreaDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/{electionAreaId}/ge-election-area-details";
        if (electionAreaId === undefined || electionAreaId === null)
            throw new Error("The parameter 'electionAreaId' must be defined.");
        url_ = url_.replace("{electionAreaId}", encodeURIComponent("" + electionAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeElectionAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeElectionAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionAreaDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionAreaDetailsDto>;
        }));
    }

    protected processGetGeElectionAreaDetails(response: HttpResponseBase): Observable<ElectionAreaDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElectionAreaDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvElectionAreaDetails(electionAreaId: string): Observable<ElectionAreaDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/{electionAreaId}/ev-election-area-details";
        if (electionAreaId === undefined || electionAreaId === null)
            throw new Error("The parameter 'electionAreaId' must be defined.");
        url_ = url_.replace("{electionAreaId}", encodeURIComponent("" + electionAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvElectionAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvElectionAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionAreaDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionAreaDetailsDto>;
        }));
    }

    protected processGetEvElectionAreaDetails(response: HttpResponseBase): Observable<ElectionAreaDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElectionAreaDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRmElectionAreaDetails(electionAreaId: string): Observable<ElectionAreaDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/{electionAreaId}/rm-election-area-details";
        if (electionAreaId === undefined || electionAreaId === null)
            throw new Error("The parameter 'electionAreaId' must be defined.");
        url_ = url_.replace("{electionAreaId}", encodeURIComponent("" + electionAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRmElectionAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRmElectionAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionAreaDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionAreaDetailsDto>;
        }));
    }

    protected processGetRmElectionAreaDetails(response: HttpResponseBase): Observable<ElectionAreaDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElectionAreaDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFaElectionAreaDetails(electionAreaId: string): Observable<FaElectionAreaDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/{electionAreaId}/fa-election-area-details";
        if (electionAreaId === undefined || electionAreaId === null)
            throw new Error("The parameter 'electionAreaId' must be defined.");
        url_ = url_.replace("{electionAreaId}", encodeURIComponent("" + electionAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaElectionAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaElectionAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaElectionAreaDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaElectionAreaDetailsDto>;
        }));
    }

    protected processGetFaElectionAreaDetails(response: HttpResponseBase): Observable<FaElectionAreaDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaElectionAreaDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionDetails(regionId: string): Observable<RegionDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/region/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDetailsDto>;
        }));
    }

    protected processGetRegionDetails(response: HttpResponseBase): Observable<RegionDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegionDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMunicipalityDetails(municipalityId: string): Observable<MunicipalityDetailsDto> {
        let url_ = this.baseUrl + "/api/detail/municipality/{municipalityId}";
        if (municipalityId === undefined || municipalityId === null)
            throw new Error("The parameter 'municipalityId' must be defined.");
        url_ = url_.replace("{municipalityId}", encodeURIComponent("" + municipalityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipalityDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipalityDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityDetailsDto>;
        }));
    }

    protected processGetMunicipalityDetails(response: HttpResponseBase): Observable<MunicipalityDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MunicipalityDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElectionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllElections(): Observable<ElectionsOverviewDto> {
        let url_ = this.baseUrl + "/api/election";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllElections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllElections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionsOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionsOverviewDto>;
        }));
    }

    protected processGetAllElections(response: HttpResponseBase): Observable<ElectionsOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElectionsOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentElection(): Observable<CurrentElectionDto> {
        let url_ = this.baseUrl + "/api/election/get-current-election";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentElectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentElectionDto>;
        }));
    }

    protected processGetCurrentElection(response: HttpResponseBase): Observable<CurrentElectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentElectionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getElectionDatesByElection(electionType: ElectionType): Observable<(ExportElectionDto | undefined)[]> {
        let url_ = this.baseUrl + "/api/election/{electionType}/get-election-dates-by-election";
        if (electionType === undefined || electionType === null)
            throw new Error("The parameter 'electionType' must be defined.");
        url_ = url_.replace("{electionType}", encodeURIComponent("" + electionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectionDatesByElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectionDatesByElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ExportElectionDto | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ExportElectionDto | undefined)[]>;
        }));
    }

    protected processGetElectionDatesByElection(response: HttpResponseBase): Observable<(ExportElectionDto | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as (ExportElectionDto | undefined)[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConstituencyListByElection(electionId: string): Observable<ExportConstituencyDto[]> {
        let url_ = this.baseUrl + "/api/export-data/{electionId}/get-constituency-list";
        if (electionId === undefined || electionId === null)
            throw new Error("The parameter 'electionId' must be defined.");
        url_ = url_.replace("{electionId}", encodeURIComponent("" + electionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstituencyListByElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstituencyListByElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportConstituencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportConstituencyDto[]>;
        }));
    }

    protected processGetConstituencyListByElection(response: HttpResponseBase): Observable<ExportConstituencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportConstituencyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionListByElection(electionId: string): Observable<ExportRegionDto[]> {
        let url_ = this.baseUrl + "/api/export-data/{electionId}/get-region-list";
        if (electionId === undefined || electionId === null)
            throw new Error("The parameter 'electionId' must be defined.");
        url_ = url_.replace("{electionId}", encodeURIComponent("" + electionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionListByElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionListByElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportRegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportRegionDto[]>;
        }));
    }

    protected processGetRegionListByElection(response: HttpResponseBase): Observable<ExportRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportRegionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportMunicipalities(electionId: string | null | undefined, regionId: string | null | undefined): Observable<ExportMunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/export-data/get-export-municipalities?";
        if (electionId !== undefined && electionId !== null)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportMunicipalities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportMunicipalities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportMunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportMunicipalityDto[]>;
        }));
    }

    protected processGetExportMunicipalities(response: HttpResponseBase): Observable<ExportMunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportMunicipalityDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNominationDistrictListByElection(constituencyId: string): Observable<ExportNominationDistrictDto[]> {
        let url_ = this.baseUrl + "/api/export-data/{constituencyId}/get-nomination-district-list";
        if (constituencyId === undefined || constituencyId === null)
            throw new Error("The parameter 'constituencyId' must be defined.");
        url_ = url_.replace("{constituencyId}", encodeURIComponent("" + constituencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNominationDistrictListByElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNominationDistrictListByElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportNominationDistrictDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportNominationDistrictDto[]>;
        }));
    }

    protected processGetNominationDistrictListByElection(response: HttpResponseBase): Observable<ExportNominationDistrictDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportNominationDistrictDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportElectionAreas(nominationDistrictId: string | null | undefined, municipalityId: string | null | undefined): Observable<ExportElectionAreaDto[]> {
        let url_ = this.baseUrl + "/api/export-data/get-export-election-areas?";
        if (nominationDistrictId !== undefined && nominationDistrictId !== null)
            url_ += "NominationDistrictId=" + encodeURIComponent("" + nominationDistrictId) + "&";
        if (municipalityId !== undefined && municipalityId !== null)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportElectionAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportElectionAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportElectionAreaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportElectionAreaDto[]>;
        }));
    }

    protected processGetExportElectionAreas(response: HttpResponseBase): Observable<ExportElectionAreaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportElectionAreaDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFaDataCsv(electionId: string | undefined, constituencyId: string | null | undefined, nominationDistrictId: string | null | undefined, electionAreaId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/export-data/export-fa-data-csv?";
        if (electionId === null)
            throw new Error("The parameter 'electionId' cannot be null.");
        else if (electionId !== undefined)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (constituencyId !== undefined && constituencyId !== null)
            url_ += "ConstituencyId=" + encodeURIComponent("" + constituencyId) + "&";
        if (nominationDistrictId !== undefined && nominationDistrictId !== null)
            url_ += "NominationDistrictId=" + encodeURIComponent("" + nominationDistrictId) + "&";
        if (electionAreaId !== undefined && electionAreaId !== null)
            url_ += "ElectionAreaId=" + encodeURIComponent("" + electionAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFaDataCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFaDataCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportFaDataCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFvDataCsv(electionId: string | undefined, constituencyId: string | null | undefined, nominationDistrictId: string | null | undefined, electionAreaId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/export-data/export-fv-data-csv?";
        if (electionId === null)
            throw new Error("The parameter 'electionId' cannot be null.");
        else if (electionId !== undefined)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (constituencyId !== undefined && constituencyId !== null)
            url_ += "ConstituencyId=" + encodeURIComponent("" + constituencyId) + "&";
        if (nominationDistrictId !== undefined && nominationDistrictId !== null)
            url_ += "NominationDistrictId=" + encodeURIComponent("" + nominationDistrictId) + "&";
        if (electionAreaId !== undefined && electionAreaId !== null)
            url_ += "ElectionAreaId=" + encodeURIComponent("" + electionAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFvDataCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFvDataCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportFvDataCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEvDataCsv(electionId: string | undefined, constituencyId: string | null | undefined, nominationDistrictId: string | null | undefined, electionAreaId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/export-data/export-ev-data-csv?";
        if (electionId === null)
            throw new Error("The parameter 'electionId' cannot be null.");
        else if (electionId !== undefined)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (constituencyId !== undefined && constituencyId !== null)
            url_ += "ConstituencyId=" + encodeURIComponent("" + constituencyId) + "&";
        if (nominationDistrictId !== undefined && nominationDistrictId !== null)
            url_ += "NominationDistrictId=" + encodeURIComponent("" + nominationDistrictId) + "&";
        if (electionAreaId !== undefined && electionAreaId !== null)
            url_ += "ElectionAreaId=" + encodeURIComponent("" + electionAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEvDataCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEvDataCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportEvDataCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportKvDataCsv(electionId: string | undefined, municipalityId: string | null | undefined, electionAreaId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/export-data/export-kv-data-csv?";
        if (electionId === null)
            throw new Error("The parameter 'electionId' cannot be null.");
        else if (electionId !== undefined)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (municipalityId !== undefined && municipalityId !== null)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (electionAreaId !== undefined && electionAreaId !== null)
            url_ += "ElectionAreaId=" + encodeURIComponent("" + electionAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportKvDataCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportKvDataCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportKvDataCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRvDataCsv(electionId: string | undefined, regionId: string | null | undefined, municipalityId: string | null | undefined, electionAreaId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/export-data/export-rv-data-csv?";
        if (electionId === null)
            throw new Error("The parameter 'electionId' cannot be null.");
        else if (electionId !== undefined)
            url_ += "ElectionId=" + encodeURIComponent("" + electionId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (municipalityId !== undefined && municipalityId !== null)
            url_ += "MunicipalityId=" + encodeURIComponent("" + municipalityId) + "&";
        if (electionAreaId !== undefined && electionAreaId !== null)
            url_ += "ElectionAreaId=" + encodeURIComponent("" + electionAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRvDataCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRvDataCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRvDataCsv(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getElectionSideNavigation(): Observable<SideNavigationLinkDto[]> {
        let url_ = this.baseUrl + "/api/overview/side-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectionSideNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectionSideNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SideNavigationLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SideNavigationLinkDto[]>;
        }));
    }

    protected processGetElectionSideNavigation(response: HttpResponseBase): Observable<SideNavigationLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SideNavigationLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeographyUnitName(geographyUnitType: GeographyUnitType | undefined, id: string | undefined): Observable<GeographyUnitSimpleDto> {
        let url_ = this.baseUrl + "/api/overview/geography-unit?";
        if (geographyUnitType === null)
            throw new Error("The parameter 'geographyUnitType' cannot be null.");
        else if (geographyUnitType !== undefined)
            url_ += "GeographyUnitType=" + encodeURIComponent("" + geographyUnitType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeographyUnitName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeographyUnitName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeographyUnitSimpleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeographyUnitSimpleDto>;
        }));
    }

    protected processGetGeographyUnitName(response: HttpResponseBase): Observable<GeographyUnitSimpleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeographyUnitSimpleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeElectionOverview(): Observable<FvEvFaElectionOverviewDto> {
        let url_ = this.baseUrl + "/api/overview/ge-election-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeElectionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeElectionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FvEvFaElectionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FvEvFaElectionOverviewDto>;
        }));
    }

    protected processGetGeElectionOverview(response: HttpResponseBase): Observable<FvEvFaElectionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvEvFaElectionOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvElectionOverview(): Observable<FvEvFaElectionOverviewDto> {
        let url_ = this.baseUrl + "/api/overview/ev-election-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvElectionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvElectionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FvEvFaElectionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FvEvFaElectionOverviewDto>;
        }));
    }

    protected processGetEvElectionOverview(response: HttpResponseBase): Observable<FvEvFaElectionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvEvFaElectionOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFaElectionOverview(): Observable<FvEvFaElectionOverviewDto> {
        let url_ = this.baseUrl + "/api/overview/fa-election-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaElectionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaElectionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FvEvFaElectionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FvEvFaElectionOverviewDto>;
        }));
    }

    protected processGetFaElectionOverview(response: HttpResponseBase): Observable<FvEvFaElectionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvEvFaElectionOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMunicipalElectionOverview(): Observable<KvElectionOverviewDto> {
        let url_ = this.baseUrl + "/api/overview/kv-election-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipalElectionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipalElectionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KvElectionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KvElectionOverviewDto>;
        }));
    }

    protected processGetMunicipalElectionOverview(response: HttpResponseBase): Observable<KvElectionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvElectionOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionalElectionOverview(): Observable<RvElectionOverviewDto> {
        let url_ = this.baseUrl + "/api/overview/regional-election-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalElectionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalElectionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RvElectionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RvElectionOverviewDto>;
        }));
    }

    protected processGetRegionalElectionOverview(response: HttpResponseBase): Observable<RvElectionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RvElectionOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionNavigation(regionId: string): Observable<SideNavigationLinkDto[]> {
        let url_ = this.baseUrl + "/api/overview/region/{regionId}/side-menu";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SideNavigationLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SideNavigationLinkDto[]>;
        }));
    }

    protected processGetRegionNavigation(response: HttpResponseBase): Observable<SideNavigationLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SideNavigationLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNominationDistrictDetailMenu(nominationDistrictId: string): Observable<SideNavigationLinkDto[]> {
        let url_ = this.baseUrl + "/api/overview/nomination-district/{nominationDistrictId}/side-menu";
        if (nominationDistrictId === undefined || nominationDistrictId === null)
            throw new Error("The parameter 'nominationDistrictId' must be defined.");
        url_ = url_.replace("{nominationDistrictId}", encodeURIComponent("" + nominationDistrictId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNominationDistrictDetailMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNominationDistrictDetailMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SideNavigationLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SideNavigationLinkDto[]>;
        }));
    }

    protected processGetNominationDistrictDetailMenu(response: HttpResponseBase): Observable<SideNavigationLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SideNavigationLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMunicipalitySideMenu(municipalityId: string): Observable<SideNavigationLinkDto[]> {
        let url_ = this.baseUrl + "/api/overview/municipality/{municipalityId}/side-menu";
        if (municipalityId === undefined || municipalityId === null)
            throw new Error("The parameter 'municipalityId' must be defined.");
        url_ = url_.replace("{municipalityId}", encodeURIComponent("" + municipalityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipalitySideMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipalitySideMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SideNavigationLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SideNavigationLinkDto[]>;
        }));
    }

    protected processGetMunicipalitySideMenu(response: HttpResponseBase): Observable<SideNavigationLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SideNavigationLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface GeNominationDistrictDetailDto {
    nominationDistrictName: string;
    voteCountStatusDto: VoteCountStatusDto | undefined;
    resultType: ResultType;
    candidateDataLoadState: CandidateDataLoadState;
    partyDetailDto: PartyDetailDto[] | undefined;
    electionAreaDetailDto: ElectionAreaNavigationItemDto[] | undefined;
    candidateResultDto: CandidateResultDto[] | undefined;
    independentCandidateNameList: IndependentCandidateDto[] | undefined;
    votingDetailOutsideDto: VotingDetailOutsideDto | undefined;
    resultSummaryDto: ResultSummaryDto;
}

export interface VoteCountStatusDto {
    recentUpdateTimestamp: Date | undefined;
    eligibleVoterPercentage: number;
    preCountPercentage: number;
    fineCountPercentage: number;
}

export enum ResultType {
    PartialResult = "PartialResult",
    PreliminaryResult = "PreliminaryResult",
    FinalResult = "FinalResult",
    NoResults = "NoResults",
}

export enum CandidateDataLoadState {
    NotLoaded = "NotLoaded",
    Loaded = "Loaded",
    Revoked = "Revoked",
}

export interface PartyDetailDto {
    partyId: string;
    partyWholeName: string;
    totalOfVotes: number;
    difference: number | undefined;
    percentage: number | undefined;
    percentageDifference: number | undefined;
    listOrganisation: ListOrganisation;
    preVotes: number | undefined;
    candidateDetailDtos: CandidateDetailDto[] | undefined;
    hasSpecifiedPersonalVotes: boolean;
}

export enum ListOrganisation {
    NotSpecified = "NotSpecified",
    CompletelyPrioritizedStandingInParallel = "CompletelyPrioritizedStandingInParallel",
    StandingByDistrict = "StandingByDistrict",
    StandingInParallel = "StandingInParallel",
    CompletelyStandingInParallel = "CompletelyStandingInParallel",
    PrioritizedStandingInParallel = "PrioritizedStandingInParallel",
    Mixed = "Mixed",
    PartyList = "PartyList",
}

export interface CandidateDetailDto {
    candidateId: string;
    name: string;
    candidateVotes: number | undefined;
}

export interface ElectionAreaNavigationItemDto {
    id: string;
    name: string;
    resultType: ResultType;
}

export interface CandidateResultDto {
    id: string;
    numberOfVotes: number | undefined;
    displayName: string;
}

export interface IndependentCandidateDto {
    name: string;
    vote: number | undefined;
}

export interface VotingDetailOutsideDto {
    numberOfEligibleVoters: number;
    numberOfElectionAreasWithPreliminary: number;
    numberOfElectionAreas: number;
    validVotes: number;
    validVotesPreviousElectionDifference: number | undefined;
    invalidVotes: number;
    invalidVotesPreviousElectionDifference: number | undefined;
    blankVotes: number;
    blankVotesPreviousElectionDifference: number | undefined;
    totalVotes: number;
    totalVotesPreviousElectionDifference: number | undefined;
}

export interface ResultSummaryDto {
    preliminaryResults: number;
    finalResults: number;
    pollingAreasCount: number;
}

export interface EvNominationDistrictDetailDto {
    nominationDistrictName: string;
    voteCountStatusDto: VoteCountStatusDto | undefined;
    resultType: ResultType;
    candidateDataLoadState: CandidateDataLoadState;
    partyDetailDto: PartyDetailDto[] | undefined;
    electionAreaDetailDto: ElectionAreaNavigationItemDto[] | undefined;
    candidateResultDto: CandidateResultDto[] | undefined;
    votingDetailOutsideDto: VotingDetailOutsideDto | undefined;
    resultSummaryDto: ResultSummaryDto;
}

export interface FaNominationDistrictDetailDto {
    candidateDataLoadState: CandidateDataLoadState;
    resultType: ResultType;
    nominationDistrictName: string;
    voteCountStatusDto: VoteCountStatusDto | undefined;
    votingDetailOutsideDto: VotingDetailOutsideDto | undefined;
    faElectionOverviewDto: FaElectionOverviewDto | undefined;
    resultSummaryDto: ResultSummaryDto;
}

export interface FaElectionOverviewDto {
    yesVotes: number | undefined;
    noVotes: number | undefined;
    yesPercentage: number | undefined;
    noPercentage: number | undefined;
}

export interface ElectionAreaDetailsDto {
    candidateDataLoadState: CandidateDataLoadState;
    resultType: ResultType;
    countStatusDto: CountStatusDto;
    candidateListResultDetailsList: CandidateListResultDetailsDto[];
    votingDetails: VotingDetailsDto;
}

export interface CountStatusDto {
    name: string;
    lastUpdate: Date | undefined;
    percentage: PercentageDto | undefined;
}

export interface PercentageDto {
    votingPercentage: number;
    preCountPercentage: number;
    fineCountPercentage: number;
}

export interface CandidateListResultDetailsDto {
    displayName: string;
    numberOfVotes: number | undefined;
    votingDifferencePreviousElection: number | undefined;
    percentages: number | undefined;
    differencePercentages: number | undefined;
    listOrganisationType: ListOrganisation | undefined;
    candidateResultListWithListVotes: CandidateResultDto[];
    hasSpecifiedPersonalVotes: boolean;
}

export interface VotingDetailsDto {
    numberOfEligibleVoters: number;
    pollingAreasCount: PollingAreasCountDto | undefined;
    electionAreaDetail: ElectionAreaDetailDto | undefined;
    validVotesCount: ValidVotesCountDto;
    invalidVotesCount: InvalidVotesCountDto;
    blankVotesCount: BlankVotesCountDto;
    totalVotesCount: TotalVotesCountDto;
}

export interface PollingAreasCountDto {
    numberOfPollingAreasHavePreliminaryCount: number;
    totalPollingAreas: number;
}

export interface ElectionAreaDetailDto {
    eligibleVotersNumber: number | undefined;
    pollingStationName: string;
    electionAreaName: string;
    address: string;
}

export interface ValidVotesCountDto {
    validVotesTotal: number;
    changeComparedToPreviousElection: number | undefined;
}

export interface InvalidVotesCountDto {
    invalidVotesTotal: number;
    changeComparedToPreviousElection: number | undefined;
}

export interface BlankVotesCountDto {
    blankVotesTotal: number;
    changeComparedToPreviousElection: number | undefined;
}

export interface TotalVotesCountDto {
    totalVotes: number;
    totalChangeComparedToPreviousElection: number | undefined;
}

export interface FaElectionAreaDetailsDto {
    candidateDataLoadState: CandidateDataLoadState;
    resultType: ResultType;
    countStatusDto: CountStatusDto | undefined;
    votingDetails: VotingDetailsDto | undefined;
    faElectionOverviewDto: FaElectionOverviewDto | undefined;
}

export interface RegionDetailsDto {
    regionCode: number;
    mapAreaList: MapAreaDto[];
    countStatusDto: CountStatusDto;
    resultType: ResultType;
    candidateDataLoadState: CandidateDataLoadState;
    candidateListResultDetailsList: CandidateListResultDetailsDto[];
    listMandateDistributionDtos: ListMandateDistributionDto[];
    electoralCoalitionList: ElectoralCoalitionDto[] | undefined;
    candidateMandateDistributionList: CandidateMandateDistributionDto[];
    listCoalitionResults: ListCoalitionResultDto[] | undefined;
    votingDetails: VotingDetailsDto;
    candidateResultDtos: CandidateResultDto[];
    resultSummaryDto: ResultSummaryDto;
    mandateDistributionBasedOnMissingResults: boolean;
}

export interface MapAreaDto {
    resultType: ResultType;
    code: string;
    displayName: string;
    id: string;
}

export interface ListMandateDistributionDto {
    id: string;
    displayName: string;
    numberOfSeats: number;
}

export interface ElectoralCoalitionDto {
    id: string;
    listLettersOrName: string;
}

export interface CandidateMandateDistributionDto {
    id: string;
    mandateNumber: number;
    displayName: string;
}

export interface ListCoalitionResultDto {
    id: string;
    listCoalitionLetter: string | undefined;
    candidateLettersList: (string | undefined)[];
}

export interface MunicipalityDetailsDto {
    countStatusDto: CountStatusDto;
    resultType: ResultType;
    candidateDataLoadState: CandidateDataLoadState;
    candidateListResultDetailsList: CandidateListResultDetailsDto[];
    listMandateDistributionDtos: ListMandateDistributionDto[] | undefined;
    electionAreaDetailDto: ElectionAreaNavigationItemDto[];
    candidateMandateDistributionList: CandidateMandateDistributionDto[];
    electoralCoalitionList: ElectoralCoalitionDto[] | undefined;
    votingDetails: VotingDetailsDto;
    listCoalitionResults: ListCoalitionResultDto[] | undefined;
    candidateResultDtos: CandidateResultDto[];
    resultSummaryDto: ResultSummaryDto;
    mandateDistributionBasedOnMissingResults: boolean;
}

export interface ElectionsOverviewDto {
    generalElections: ElectionDto[];
    regionalElections: ElectionDto[];
    municipalElections: ElectionDto[];
    europeanParliamentElections: ElectionDto[];
    referendums: ElectionDto[];
    activeElections: ElectionDto[];
}

export interface ElectionDto {
    id: string;
    electionName: string;
    electionDate: Date;
    electionType: ElectionType;
    title: string | undefined;
}

export enum ElectionType {
    GeneralElection = "GeneralElection",
    RegionalElection = "RegionalElection",
    MunicipalElection = "MunicipalElection",
    EuropeanParliamentElection = "EuropeanParliamentElection",
    Referendum = "Referendum",
}

export interface CurrentElectionDto {
    id: string;
    electionName: string;
    electionType: ElectionType;
    electionDate: Date;
    isDayOfElectionOrLater: boolean;
    referendumTitle: string | undefined;
}

export interface ExportElectionDto {
    electionId: string;
    electionDate: Date;
}

export interface ExportConstituencyDto {
    id: string;
    name: string;
}

export interface ExportRegionDto {
    id: string;
    name: string;
}

export interface ExportMunicipalityDto {
    id: string;
    name: string;
}

export interface ExportNominationDistrictDto {
    id: string;
    name: string;
}

export interface ExportElectionAreaDto {
    id: string;
    name: string;
}

export interface SideNavigationLinkDto {
    title: string;
    id: string;
    children: SideNavigationLinkDto[];
    sideNaviationLinkType: SideNaviationLinkType;
}

export enum SideNaviationLinkType {
    MultiMemberConstituency = "MultiMemberConstituency",
    NominationDistrict = "NominationDistrict",
    PollingDistrict = "PollingDistrict",
    Municipality = "Municipality",
    Region = "Region",
}

export interface GeographyUnitSimpleDto {
    name: string;
}

export enum GeographyUnitType {
    NominationDistrict = "NominationDistrict",
    Region = "Region",
    Municipality = "Municipality",
    PollingDistrict = "PollingDistrict",
}

export interface FvEvFaElectionOverviewDto {
    voteCountStatusDto: VoteCountStatusDto;
    candidateDataLoadState: CandidateDataLoadState;
    resultType: ResultType;
    recentUpdatedNominationDistrictDtoList: RecentUpdatedNominationDistrictDto[];
    faElectionOverviewDto: FaElectionOverviewDto | undefined;
    mapAreaDtoList: MapAreaDto[];
    resultSummaryDto: ResultSummaryDto;
    partyResultDtoList: PartyResultDto[] | undefined;
    candidateResultListDtoList: CandidateResultDto[] | undefined;
    electoralCoalitionDtos: ElectoralCoalitionDto[] | undefined;
}

export interface RecentUpdatedNominationDistrictDto {
    id: string;
    nominationDistrictName: string;
    lastUpdate: Date | undefined;
}

export interface PartyResultDto {
    partyName: string;
    votingPercentage: number;
}

export interface KvElectionOverviewDto {
    municipalities: MunicipalityDto[];
    mapAreas: MapAreaDto[];
}

export interface MunicipalityDto {
    id: string;
    name: string;
    countingPercentage: number | undefined;
    lastUpdate: Date | undefined;
}

export interface RvElectionOverviewDto {
    regions: RegionDto[];
    mapAreas: MapAreaDto[];
}

export interface RegionDto {
    id: string;
    name: string;
    countingPercentage: number | undefined;
    lastUpdate: Date | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}